import { render, staticRenderFns } from "./component-flow.vue?vue&type=template&id=5681e431&scoped=true"
import script from "./component-flow.vue?vue&type=script&lang=ts"
export * from "./component-flow.vue?vue&type=script&lang=ts"
import style0 from "./component-flow.vue?vue&type=style&index=0&id=5681e431&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5681e431",
  null
  
)

export default component.exports